export function validateQuantity(value: string | undefined): string | null {
  if (value === undefined || value === "") return null // optional, valid
  const parsed = Number(value)
  if (!Number.isFinite(parsed)) return "Must be a number"
  if (parsed < 0) return "Must be zero or greater"
  if (parsed > 999_999_999.99) return "Value is too large"
  // 2-decimal-place check via string regex; reject leading zeros (e.g. '0213')
  if (!/^(0|[1-9]\d*)(\.\d{1,2})?$/.test(value)) return "Maximum 2 decimal places"
  return null
}
